module.exports = __webpack_public_path__ + "static/img/giftcard.cd43eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftcard.png
// module id = gzOW
// module chunks = 0